;(function (angular) {
  'use strict'

  angular
    .module('kilo.common.directives')
    .directive('zlDragDrop', function () {
      return {
        controller: function () {},
        scope: {},
        controllerAs: 'dragDropCtrl',
        bindToController: {
          zlDrag: '=',
          zlDrop: '&'
        },
        link: function (scope, element) {
          var el = element[0]

          if (scope.dragDropCtrl.zlDrag) {
            el.draggable = true

            el.addEventListener(
              'dragstart',
              function (e) {
                e.dataTransfer.effectAllowed = 'move'
                e.dataTransfer.setData('Text', JSON.stringify(scope.dragDropCtrl.zlDrag))
                this.classList.add('drag')
                return false
              },
              false
            )

            el.addEventListener(
              'dragend',
              function (e) {
                this.classList.remove('drag')
                return false
              },
              false
            )

            el.addEventListener(
              'dragover',
              function (e) {
                e.dataTransfer.dropEffect = 'move'
                if (e.preventDefault) e.preventDefault()
                this.classList.add('over')
                return false
              },
              false
            )
          }

          if (scope.dragDropCtrl.zlDrop) {
            el.addEventListener(
              'drop',
              function (e) {
                e.preventDefault()
                e.stopPropagation()
                if (e.stopPropagation) e.stopPropagation()
                this.classList.remove('over')
                scope.$apply(function () {
                  scope.dragDropCtrl.zlDrop({ $data: JSON.parse(e.dataTransfer.getData('Text')), $event: e })
                })
                return false
              },
              false
            )

            el.addEventListener(
              'dragenter',
              function (e) {
                this.classList.add('over')
                return false
              },
              false
            )

            el.addEventListener(
              'dragleave',
              function (e) {
                this.classList.remove('over')
                return false
              },
              false
            )
          }
        }
      }
    })
    .run(registerGlobalDragListeners)

  /*
   * Les directives zlDragDrop, conditionsDragDrop et lineDrop enregistraient, dans leur link,
   * À CHAQUE INSTANCE, deux écouteurs window ('dragover' et 'drop') jamais retirés. Ces handlers
   * partageant le contexte de closure du link (scope, element), window retenait chaque instance,
   * son scope et via $parent toute la page (contrôleur, données, DOM) : fuite mémoire.
   * Ces preventDefault globaux restent nécessaires (autoriser le drop, notamment sous Firefox,
   * et empêcher le navigateur d'ouvrir un fichier lâché hors zone) : on les enregistre donc
   * une seule fois pour toute l'application.
   */
  function registerGlobalDragListeners () {
    window.addEventListener('dragover', preventDefault, false)
    window.addEventListener('drop', preventDefault, false)
  }

  function preventDefault (e) {
    e.preventDefault()
  }
})(window.angular)
